/**
 * Add your config changes here.
 * @module config
 * @example
 * export const settings = {
 *   ...defaultSettings,
 *   port: 4300,
 *   listBlockTypes: {
 *     ...defaultSettings.listBlockTypes,
 *     'my-list-item',
 *   }
 * }
 */

import ContextNavigation from '@plone/volto/components/theme/Navigation/ContextNavigation';

import sliderSVG from '@plone/volto/icons/slider.svg';
import newsSVG from '@plone/volto/icons/news.svg';
import summarySVG from '@plone/volto/icons/summary.svg';
import imagesSVG from '@plone/volto/icons/images.svg';
import enterpriseSVG from '@plone/volto/icons/enterprise.svg';
import heroSVG from '@plone/volto/icons/hero.svg';
import blogSVG from '@plone/volto/icons/blog.svg';
import pageSVG from '@plone/volto/icons/page.svg';
import fileSVG from '@plone/volto/icons/file.svg';
import folderSVG from '@plone/volto/icons/folder.svg';
import linkSVG from '@plone/volto/icons/link.svg';
import imageSVG from '@plone/volto/icons/image.svg';
import bookSVG from '@plone/volto/icons/book.svg';
import eventSVG from '@plone/volto/icons/event.svg';

import parallaxSVG from 'volto-fzj-internet/icons/block_icn_parallax-block.svg';
import institutsSliderSVG from 'volto-fzj-internet/icons/block_icn_institutsslider.svg';
import karousselSVG from 'volto-fzj-internet/icons/block_icn_karoussel.svg';
import tabSVG from 'volto-fzj-internet/icons/block_icn_anreisser-tab.svg';
import tabBlockSVG from 'volto-fzj-internet/icons/block_icn_tab-block.svg';
import teaserTrennerSVG from 'volto-fzj-internet/icons/block_icn_teaser-trenner-bild.svg';
import teaserGridSVG from 'volto-fzj-internet/icons/block_icn_teaser-grid.svg';
import memberSVG from 'volto-fzj-internet/icons/block_icn_mitglieder.svg';
import researchGroupSVG from 'volto-fzj-internet/icons/block_icn_forschungsgruppe.svg';
import textPillWithStyleSVG from 'volto-fzj-internet/icons/block_icn_text-mit-auflistung.svg';
import headlineSVG from 'volto-fzj-internet/icons/block_icn_ueberschrift.svg';
import socialMediaSVG from 'volto-fzj-internet/icons/block_icn_portal-social-media.svg';
import gridSVG from 'volto-fzj-internet/icons/block_icn_grid.svg';
import accordionSVG from 'volto-fzj-internet/icons/block_icn_akkordeon.svg';
import buttonSVG from 'volto-fzj-internet/icons/block_icn_button.svg';
import textSVG from 'volto-fzj-internet/icons/block_icn_text.svg';
import tableSVG from 'volto-fzj-internet/icons/block_icn_tabelle.svg';
import tocSVG from 'volto-fzj-internet/icons/block_icn_inhaltsverzeichnis.svg';
import mapSVG from 'volto-fzj-internet/icons/block_icn_maps.svg';
import htmlSVG from 'volto-fzj-internet/icons/block_icn_html.svg';
import portalTargetGroupSVG from 'volto-fzj-internet/icons/block_icn_portal-zielgruppen.svg';
import listingSVG from 'volto-fzj-internet/icons/block_icn_auflistung.svg';
import freedomSVG from '@plone/volto/icons/freedom.svg';

import quoteSVG from '@plone/volto/icons/quote.svg';

import { solrSearchContent } from './actions';
import { Search } from '@plone/volto/components';

import {
  GridViewBlock,
  GridEditBlock,
} from '@kitconcept/volto-blocks-grid/components';

import CarouselView from '@kitconcept/volto-carousel-block/components/View';
import CarouselEdit from '@kitconcept/volto-carousel-block/components/Edit';

import HiERNMembersView from 'volto-hi-ern/components/Blocks/Members/View';
import HiERNMembersEdit from 'volto-hi-ern/components/Blocks/Members/Edit';
import HiERNAZListView from 'volto-hi-ern/components/Blocks/AZList/View';
import HiERNAZListEdit from 'volto-hi-ern/components/Blocks/AZList/Edit';

import {
  TeaserTabView,
  TeaserTabEdit,
  FileListingVariation,
  TabBlockEdit,
  TabBlockView,
  ImageListingTemplate,
  NewsListingTemplate,
  NewsImageListingTemplate,
  EventListingTemplate,
  TeaserWithLinkEdit,
  TeaserWithLinkView,
  HeadlineBlockEdit,
  HeadlineBlockView,
  SocailMediaEdit,
  SocailMediaView,
  SliderNewEdit,
  SliderNewView,
  AktuellesEdit,
  AktuellesView,
  AktuellesListing,
  InstitutSliderEdit,
  InstitutSliderView,
  StickyMenuWidget,
  PreFooterWidget,
  FooterWidget,
  ColorChooserWidget,
  EventView,
  MeldungView,
  ResearchGroupView,
  ParallaxEdit,
  ParallaxView,
  MembersEdit,
  MembersView,
  IntroductionEdit,
  IntroductionView,
  TopSideFacets,
  GridListingTwoColumns,
  GridListingThreeColumns,
  GridListingFourColumns,
  AZListEdit,
  AZListView,
  MemberView,
  MemberListEdit,
  MemberListView,
  PersonsListingsAdapter,
  HighlightTeaserEdit,
  HighlightTeaserView,
  JobListingView,
  JobFilterBlockView,
  JobFilterBlockEdit,
  JobOfferView,
  EmbeddedPageView,
  HighlightView,
  HighlightEdit,
  AltmetricBlockEdit,
  AltmetricBlockView,
  AwardsListing,
  AwardView,
  ProjectView,
  ProjectListing,
  JobOfferListing,
  CartView,
  TenderView,
  ETrackerScript,
  IconBlockView,
  IconBlockEdit,
  HighlightTeaserParallaxEdit,
  HighlightTeaserParallaxView,
  QuoteBlockView,
  QuoteBlockEdit,
  BlogPostListing,
  BlogPostGrid,
  CentralProfile,
  UnlockFormView,
  CartBasket,
  CartCheckout,
} from './components';

import { TeaserTransparentTemplate } from 'volto-fzj-internet/components';

import {
  nearestinstitut,
  fzjsettings,
  contactform,
  unlockform,
  solrsearch,
  institutlist,
  cart,
  jobOfferSearch,
  relations,
  searchSuggestions,
} from 'volto-fzj-internet/reducers';

import ImageGalleryListingBlockTemplate from '@plone/volto/components/manage/Blocks/Listing/ImageGallery';
import SummaryListingBlockTemplate from 'volto-fzj-internet/components/Blocks/ListingTemplate/SummaryTemplate';
import DefaultListingBlockTemplate from '@plone/volto/components/manage/Blocks/Listing/DefaultTemplate';
import { defineMessages } from 'react-intl';
import { renderLinkElement } from './customizations/@plone/volto-slate/editor/render';

import { TextBlockView, TextBlockEdit } from '@plone/volto-slate/blocks/Text';

import configRegistry from '@plone/volto/registry';
import '@plone/volto/config';

import * as searchResultItems from 'volto-fzj-internet/customizations/volto/components/theme/Search/resultItems';

import AlignWidgetNext from './components/Widgets/AlignWidget';

import { BgColorSchema } from 'volto-fzj-internet/components/Styles/BackgroundColorStyle/schema';
import { FullWidthStyle } from 'volto-fzj-internet/components/Styles/FullWidthStyle/schema';
import BlockStyleWrapper from 'volto-fzj-internet/components/Styles/Wrapper/BlockStyleWrapper';
import GridStyleWrapper from 'volto-fzj-internet/components/Styles/Wrapper/GridStyleWrapper';
import { composeSchema } from '@plone/volto/helpers';

import TeaserViewBlock from '@plone/volto/components/manage/Blocks/Teaser/View';
import TeaserEditBlock from '@plone/volto/components/manage/Blocks/Teaser/Edit';
import { TeaserSchema } from '@plone/volto/components/manage/Blocks/Teaser/schema';
import { TeaserBlockDataAdapter } from '@plone/volto/components/manage/Blocks/Teaser/adapter';

import DefaultBody from './components/Blocks/Teaser/DefaultBody'

import cloneDeep from 'lodash/cloneDeep';
import Image from './components/Image/Image';

const additionalExpressMiddlewareServerConfig =
  typeof __SERVER__ !== 'undefined' && __SERVER__
    ? require('./express-middleware').default
    : false;


defineMessages({
  Datenschutz: {
    id: 'Datenschutz',
    defaultMessage: 'Datenschutz',
  },
  member: {
    id: 'Member',
    defaultMessage: 'Member',
  },
  Barrierefreiheit: {
    id: 'Barrierefreiheit',
    defaultMessage: 'Barrierefreiheit',
  },
  Impressum: {
    id: 'Impressum',
    defaultMessage: 'Impressum',
  },
  Default: {
    id: 'Default',
    defaultMessage: 'Default',
  },
  root: {
    id: 'Root',
    defaultMessage: 'Root',
  },
  common: {
    id: 'common',
    defaultMessage: 'Common',
  },
  slateTable: {
    id: 'slateTable',
    defaultMessage: 'Table',
  },
  headline: {
    id: 'headline',
    defaultMessage: 'Headline',
  },
  slateSidebarDefaultMessage: {
    id: 'This block does not have any configuration options.',
    defaultMessage: 'This block does not have any configuration options.',
  },
  seeOverview: {
    id: 'see overview',
    defaultMessage: 'See Overview',
  },
  manageContent: {
    id: 'Manage_content',
    defaultMessage: 'Manage content...',
  },
  accordion: {
    id: 'Accordion',
    defaultMessage: 'Accordion',
  },
  members: {
    id: 'Members',
    defaultMessage: 'Members',
  },
  researchGroupIntroduction: {
    id: 'Research Group Introduction',
    defaultMessage: 'Research Group Introduction',
  },
  // To overcome the error messages in console until volto-slate is merged
  addLink: {
    id: 'Add link',
    defaultMessage: 'Add link',
  },
  researchGroup: {
    id: 'Research Group',
    defaultMessage: 'Research Group',
  },
  transparentGrid: {
    id: 'Teaser Transparent Grid',
    defaultMessage: 'Teaser Transparent Grid',
  },
  persons: {
    id: 'Persons',
    defaultMessage: 'Persons',
  },
  personsWithoutImage: {
    id: 'Persons without Image',
    defaultMessage: 'Persons without Image',
  },
  personsWithoutInstitutes: {
    id: 'Persons without Institutes',
    defaultMessage: 'Persons without Institutes',
  },
  personsWithoutInstitutsOrImages: {
    id: 'Persons without Instituts/Images',
    defaultMessage: 'Persons without Instituts/Images',
  },
  personsGrid: {
    id: 'Persons Grid',
    defaultMessage: 'Persons Grid',
  },
  personsGridShort: {
    id: 'Persons Grid short',
    defaultMessage: 'Persons Grid short',
  },
  personsGridWithoutImage: {
    id: 'Persons Grid without image',
    defaultMessage: 'Persons Grid without image',
  },
  summary: {
    id: 'Summary',
    defaultMessage: 'Summary',
  },
  imageListing: {
    id: 'Image gallery',
    defaultMessage: 'Image gallery',
  },
  newsListing: {
    id: 'News',
    defaultMessage: 'News',
  },
  newsImageListing: {
    id: 'News with image',
    defaultMessage: 'News with image',
  },
  eventListing: {
    id: 'Events',
    defaultMessage: 'Events',
  },
  fileListing: {
    id: 'Files/Downloads',
    defaultMessage: 'Files/Downloads',
  },
  imageGallery: {
    id: 'Image slider',
    defaultMessage: 'Image slider',
  },
  cardsListing: {
    id: 'Cards',
    defaultMessage: 'Cards',
  },
  GridListingTwoColumns: {
    id: 'Grid Listing (2 Columns)',
    defaultMessage: 'Grid Listing (2 Columns)',
  },
  GridListingThreeColumns: {
    id: 'Grid Listing (3 Columns)',
    defaultMessage: 'Grid Listing (3 Columns)',
  },
  GridListingFourColumns: {
    id: 'Grid Listing (4 Columns)',
    defaultMessage: 'Grid Listing (4 Columns)',
  },
  searchResults: {
    id: 'Search results',
    defaultMessage: 'Search results',
  },
  separator: {
    id: 'Seperator',
    defaultMessage: 'Seperator',
  },
  // TypeSearchWords is here because currently in customized Search.jsx
  TypeSearchWords: {
    id: 'Search...',
    defaultMessage: 'Search...',
  },
  EmbeddedPage: {
    id: 'Embedded Page',
    defaultMessage: 'Embedded Page',
  },
  Event: {
    id: 'Event',
    defaultMessage: 'Event',
  },
  Joboffer: {
    id: 'Joboffer',
    defaultmessage: 'Joboffer',
  },
  Frontpage: {
    id: 'Frontpage',
    defaultMessage: 'Frontpage',
  },
  January: {
    id: 'January',
    defaultMessage: 'January',
  },
  February: {
    id: 'February',
    defaultMessage: 'February',
  },
  March: {
    id: 'March',
    defaultMessage: 'March',
  },
  May: {
    id: 'May',
    defaultMessage: 'May',
  },
  June: {
    id: 'June',
    defaultMessage: 'June',
  },
  July: {
    id: 'July',
    defaultMessage: 'July',
  },
  October: {
    id: 'October',
    defaultMessage: 'October',
  },
  December: {
    id: 'December',
    defaultMessage: 'December',
  },
  print: {
    id: 'print',
    defaultMessage: 'print',
  },
  toTheTop: {
    id: 'to the top',
    defaultMessage: 'to the top',
  },
  results: {
    // Ergebnisse
    id: 'results',
    defaultMessage: 'results',
  },
  searchLocalizedLabel: {
    // Suchergebnisse anzeigen für:
    id: 'searchLocalizedLabel',
    defaultMessage: 'Show results for:',
  },
  searchGlobalized: {
    // Alle webauftritte (global)
    id: 'searchGlobalized',
    defaultMessage: 'All content (global)',
  },
  searchLocalized: {
    // Nur dieser webauftritt
    id: 'searchLocalized',
    defaultMessage: 'This subfolder only',
  },
  pageNotFound: {
    id: 'delete',
    defaultMessage: 'delete',
  },
  pageNotAvailable: {
    id:
      'The page you were looking for is unfortunately not available (anymore).',
    defaultMessage:
      'The page you were looking for is unfortunately not available (anymore).',
  },
  useSearchPrompt: {
    id:
      'Please use the search function or alternative entry points to reach the desired information.',
    defaultMessage:
      'Please use the search function or alternative entry points to reach the desired information.',
  },
  goToSearch: {
    id: 'Go to search',
    defaultMessage: 'Go to',
  },
  goToInstitutes: {
    id: 'Go to institutes',
    defaultMessage: 'Go to',
  },
  goToContact: {
    id: 'Go to contact',
    defaultMessage: 'Go to',
  },
  search: {
    id: 'Search',
    defaultMessage: 'Search',
  },
  institutes: {
    id: 'institutes',
    defaultMessage: 'institutes',
  },
  contactVisitor: {
    id: 'Contact & Visitor information',
    defaultMessage: 'Contact & Visitor information',
  },
  thankYou: {
    id: 'Thank you',
    defaultMessage: 'Thank you',
  },
  deleteConfirmSingleItem: {
    id: 'Delete this item?',
    defaultMessage: 'Delete this item?',
  },
  deleteConfirmMultipleItems: {
    id: 'Delete selected items?',
    defaultMessage: 'Delete selected items?',
  },
  showAllSearchResults: {
    id: 'Show all search results...',
    defaultMessage: 'Show all search results...',
  },
  closeSearch: {
    id: 'Close search',
    defaultMessage: 'Close search',
  },
  urlClipboardCopy: {
    id: 'Link copied to clipboard',
    defaultMessage: 'Anchor link copied to the clipboard',
  },
  dataProtection: {
    id: 'Data Protection',
    defaultMessage: 'Data Protection',
  },
  accessibility: {
    id: 'Accessibility',
    defaultMessage: 'Accessibility',
  },
  usernameTitle: {
    id: 'label_my_username_is',
    defaultMessage: 'My username is',
  },
  documents: {
    id: 'Documents',
    defaultMessage: 'Documents',
  },
  images: {
    id: 'Images',
    defaultMessage: 'Images',
  },
  scrollTop: {
    id: 'scroll to top',
    defaultMessage: 'scroll to top',
  },
  about: {
    id: 'About',
    defaultMessage: 'About',
  },
  leaveareply: {
    id: 'Leave a Reply',
    defaultMessage: 'Leave a Reply',
  },
  textwithbackground: {
    id: 'Text with background color',
    defaultMessage: 'Text with background color',
  },
});

export default function applyConfig(config) {
  config.addonReducers = {
    ...config.addonReducers,
    nearestinstitut,
    fzjsettings,
    contactform,
    unlockform,
    solrsearch,
    institutlist,
    cart,
    jobOfferSearch,
    relations,
    searchSuggestions,
  };

  config.settings.slate.toolbarButtons = config.settings.slate.toolbarButtons.filter(
    (item) => item !== 'table',
  );
  config.settings.slate.expandedToolbarButtons = config.settings.slate.expandedToolbarButtons.filter(
    (item) => item !== 'table',
  );
  config.settings.slate.toolbarButtons = [
    ...config.settings.slate.toolbarButtons,
    'sub',
    'sup',
  ];
  config.settings.slate.useLinkedHeadings = true;
  config.settings.contentIcons.Meldung = newsSVG;
  config.settings.contentIcons.EmbeddedPage = summarySVG;
  config.settings.contentIcons.Institut = enterpriseSVG;
  config.settings.contentIcons.Institutsbereich = enterpriseSVG;
  config.settings.contentIcons.Member = memberSVG;
  config.settings.contentIcons['Research Group'] = researchGroupSVG;

  config.settings.isMultilingual = true;
  config.settings.hasWorkingCopySupport = true;
  config.settings.listingPreviewImageField = 'preview_image';
  config.settings.supportedLanguages = process.env.RAZZLE_FZJ_LANGUAGES
    ? process.env.RAZZLE_FZJ_LANGUAGES.split(',')
    : ['de', 'en'];
  config.settings.defaultLanguage =
    process.env.RAZZLE_FZJ_DEFAULT_LANGUAGE || 'de';
  config.settings.navDepth = 3;

  config.settings.isFZJProject = process.env.RAZZLE_FZJ_PROJECT || false;
  config.settings.isHiERNProject = process.env.RAZZLE_FZJ_HI_ERN || false;

  config.settings.slate.elements.h1 = renderLinkElement('h1');
  config.settings.slate.elements.h2 = renderLinkElement('h2');
  config.settings.slate.elements.h3 = renderLinkElement('h3');
  config.settings.slate.elements.h4 = renderLinkElement('h4');
  config.settings.jobofferurl = 'https://recruiting.fz-juelich.de';

  config.widgets.widget.stickymenu = StickyMenuWidget;
  config.widgets.widget.prefooter = PreFooterWidget;
  config.widgets.widget.footer = FooterWidget;
  config.widgets.widget.colorChooser = ColorChooserWidget;

  config.widgets.widget.align_next = AlignWidgetNext;

  config.widgets.id.main_bg_color = ColorChooserWidget;

  config.views.contentTypesViews.Event = EventView;
  config.views.contentTypesViews.Meldung = MeldungView;
  config.views.contentTypesViews.Member = MemberView;
  config.views.contentTypesViews['Research Group'] = ResearchGroupView;
  config.views.contentTypesViews['JobOfferContainer'] = JobListingView;
  config.views.contentTypesViews['Joboffer'] = JobOfferView;
  config.views.contentTypesViews.EmbeddedPage = EmbeddedPageView;
  config.views.contentTypesViews.Project = ProjectView;
  config.views.contentTypesViews.Award = AwardView;
  config.views.contentTypesViews.Cart = CartView;
  config.views.contentTypesViews.Tender = TenderView;
  //config.views.contentTypesViews.Post = BlogPost;

  config.settings.apiExpanders = [
    { match: '', GET_CONTENT: ['fzjsettings,nearest-institut'] },
  ];

  // Do not show the sidebar in slate blocks
  config.blocks.blocksConfig.slate.sidebarTab = 0;
  config.blocks.blocksConfig.accordion.allowedBlocks = [
    'slate',
    'listing',
    'memberList',
    'image',
  ];

  // config.blocks.blocksConfig.search.restricted = true;
  // config.blocks.blocksConfig.form.restricted = true;

  config.blocks.blocksConfig.search.variations = [
    {
      id: 'facetsTopSide',
      title: 'Facets on top',
      view: TopSideFacets,
      isDefault: true,
    },
  ];

  // const AVAILABLE_COLORS_DEFAULT = [
  //   '#ebebeb',
  //   '#023d6b',
  //   '#ddeeff',
  //   '#eb5f73',
  //   '#b9d25f',
  // ];
  // const AVAILABLE_COLORS_PROJECT = [
  //   '#ebebeb',
  //   '#023d6b',
  //   '#9c87be', // purple
  //   '#ddeeff',
  //   '#8dc3aa', // mint
  //   '#b9d25f',
  //   '#fdd06d', // orange
  //   '#eb5f73',
  //   '#cd7fb4', // lilac
  // ];
  // const AVAILABLE_COLORS_HIERN = [
  //   '#http://localhost:3000/de/institute', // blue
  //   '#64c1be', // blue-green
  //   '#bbcf00', // lightgreen
  //   '#009a3d', // dark green
  //   '#8c8c8c', // lightgrey
  //   '#dee1e3', // lightergrey
  //   '#575757', // grey
  //   '#3e4c54', // blackgrey
  // ];
  // const AVAILABLE_COLORS = config.settings.isFZJProject
  //   ? AVAILABLE_COLORS_PROJECT
  //   : config.settings.isHiERNProject
  //   ? AVAILABLE_COLORS_HIERN
  //   : AVAILABLE_COLORS_DEFAULT;

  // config.settings.availableColors = AVAILABLE_COLORS.map((entry) => ({
  //   name: entry,
  //   value: entry,
  // }));

  //
  //

  // Contains all stylable colors
  const AVAILABLE_COLORS = [
    {
      name: 'grey',
      label: 'grey',
      style: { '--background-color': '#ebebeb' },
    },
    {
      name: 'darkBlue',
      label: 'darkBlue',
      style: { '--background-color': '#023d6b' },
    },
    {
      name: 'lightBlue',
      label: 'lightBlue',
      style: { '--background-color': '#ddeeff' },
    },
    {
      name: 'red',
      label: 'red',
      style: { '--background-color': '#eb5f73' },
    },
    {
      name: 'green',
      label: 'green',
      style: { '--background-color': '#b9d25f' },
    },
    {
      name: 'purple',
      label: 'purple',
      style: { '--background-color': '#9c87be' },
    },
    {
      name: 'mint',
      label: 'mint',
      style: { '--background-color': '#8dc3aa' },
    },
    {
      name: 'orange',
      label: 'orange',
      style: { '--background-color': '#fdd06d' },
    },
    {
      name: 'lilac',
      label: 'lilac',
      style: { '--background-color': '#cd7fb4' },
    },
    {
      name: 'blue-green',
      label: 'blue-green',
      style: { '--background-color': '#64c1be' },
    },
    {
      name: 'lightgreen',
      label: 'lightgreen',
      style: { '--background-color': '#bbcf00' },
    },
    {
      name: 'darkgreen',
      label: 'darkgreen',
      style: { '--background-color': '#009a3d' },
    },
    {
      name: 'lightgrey',
      label: 'lightgrey',
      style: { '--background-color': '#8c8c8c' },
    },
    {
      name: 'lightergrey',
      label: 'lightergrey',
      style: { '--background-color': '#dee1e3' },
    },
    {
      name: 'hierngrey',
      label: 'hierngrey',
      style: { '--background-color': '#575757' },
    },
    {
      name: 'blackgrey',
      label: 'blackgrey',
      style: { '--background-color': '#3e4c54' },
    },
  ];

  const fzjcolorfilter = ['grey', 'darkBlue', 'lightBlue', 'green', 'red'];
  const fzjprojectcolorfilter = [
    'grey',
    'darkBlue',
    'purple',
    'lightBlue',
    'mint',
    'green',
    'orange',
    'red',
    'lilac',
  ];
  const hierncolorfilter = [
    'blue-green',
    'lightgreen',
    'darkgreen',
    'lightgrey',
    'lightergrey',
    'hierngrey',
    'blackgrey',
  ];

  const colorfilter = config.settings.isFZJProject
    ? fzjprojectcolorfilter
    : config.settings.isHiERNProject
    ? hierncolorfilter
    : fzjcolorfilter;

  // Select only relevant colors
  config.settings.availableColors = AVAILABLE_COLORS.filter((color) =>
    colorfilter.includes(color.name),
  );

  //const result = words.filter((word) => word.length > 6);

  config.blocks.blocksConfig.search.extensions.facetWidgets.rewriteOptions = (
    name,
    choices,
  ) => {
    switch (name) {
      case 'review_state':
        return choices.map((opt) => ({
          ...opt,
          label: opt.label.replace(/\[.+\]/, '').trim(),
        }));
      case 'year':
        return choices.reverse();
      default:
        return choices;
    }
  };

  config.blocks.groupBlocksOrder.push({
    id: 'Research Group',
    title: 'Research Group',
  });
  config.blocks.groupBlocksOrder.push({ id: 'Career', title: 'Career' });

  config.blocks.groupBlocksOrder.splice(2, 0, {
    id: 'teasers',
    title: 'Teasers',
  });

  config.blocks.requiredBlocks = [];

  //config.blocks.blocksConfig
  config.blocks.blocksConfig.leadimage.restricted = true;

  config.blocks.blocksConfig.teaser.imageScale = 'teaser';

  config.blocks.blocksConfig.hero.restricted = true;

  config.blocks.blocksConfig.__grid.icon = gridSVG;
  (config.blocks.blocksConfig.__grid.schemaEnhancer = composeSchema(
    BgColorSchema,
    FullWidthStyle,
  )),
    (config.blocks.blocksConfig.__grid.view = GridStyleWrapper(GridViewBlock));
  config.blocks.blocksConfig.__grid.edit = GridStyleWrapper(GridEditBlock);

  config.blocks.blocksConfig.__grid.gridAllowedBlocks = [
    'teaser',
    'image',
    'listing',
    'slate',
    'buttonBlock',
    'infoCard',
    'icon',
    '__button',
  ];

  config.blocks.blocksConfig.accordion.icon = accordionSVG;

  config.blocks.blocksConfig.slate.icon = textSVG;

  config.blocks.blocksConfig.slateTable.icon = tableSVG;

  config.blocks.blocksConfig.toc.icon = tocSVG;

  config.blocks.blocksConfig.maps.icon = mapSVG;

  config.blocks.blocksConfig.html.icon = htmlSVG;

  config.blocks.blocksConfig.listing.variations = [
    {
      id: 'default',
      title: 'Standard',
      isDefault: true,
      template: DefaultListingBlockTemplate,
    },
    {
      id: 'summary',
      title: 'Summary',
      template: SummaryListingBlockTemplate,
    },
    {
      id: 'imageListing',
      title: 'Image gallery',
      template: ImageListingTemplate,
    },
    {
      id: 'newsListing',
      title: 'News',
      template: NewsListingTemplate,
    },
    {
      id: 'newsImageListing',
      title: 'News with image',
      template: NewsImageListingTemplate,
    },
    {
      id: 'eventListing',
      title: 'Events',
      template: EventListingTemplate,
    },
    {
      id: 'fileListing',
      title: 'Files/Downloads',
      template: FileListingVariation,
    },
    {
      id: 'aktuelles',
      title: 'Aktuelles',
      template: AktuellesListing,
    },
    {
      id: 'imageGallery',
      title: 'Image slider',
      template: ImageGalleryListingBlockTemplate,
    },
    {
      id: 'GridListingTwoColumns',
      title: 'Grid Listing (2 Columns)',
      template: GridListingTwoColumns,
    },
    {
      id: 'GridListingThreeColumns',
      title: 'Grid Listing (3 Columns)',
      template: GridListingThreeColumns,
    },
    {
      id: 'cardsListing',
      title: 'Grid Listing (4 Columns)',
      template: GridListingFourColumns,
    },
    {
      id: 'persons',
      title: 'Persons',
      template: PersonsListingsAdapter,
      fullobjects: 1,
    },
    {
      id: 'personsWithoutImage',
      title: 'Persons without Image',
      template: PersonsListingsAdapter,
      fullobjects: 1,
    },
    {
      id: 'personsWithoutInstitutes',
      title: 'Persons without Institutes',
      template: PersonsListingsAdapter,
      fullobjects: 1,
    },
    {
      id: 'personsWithoutInstitutsOrImages',
      title: 'Persons without Instituts/Images',
      template: PersonsListingsAdapter,
      fullobjects: 1,
    },
    {
      id: 'personsGrid',
      title: 'Persons Grid',
      template: PersonsListingsAdapter,
      fullobjects: 1,
    },
    {
      id: 'personsGridWithoutImage',
      title: 'Persons Grid without image',
      template: PersonsListingsAdapter,
      fullobjects: 1,
    },
    {
      id: 'projectListing',
      title: 'Project Listing',
      template: ProjectListing,
    },
    {
      id: 'awardsListing',
      title: 'Awards Listing',
      template: AwardsListing,
      fullobjects: 1,
    },
    {
      id: 'jobOfferListing',
      title: 'JobOffer Listing',
      template: JobOfferListing,
    },
    {
      id: 'blogPostListing',
      title: 'Blogpost Listing',
      template: BlogPostListing,
    },
    {
      id: 'blogPostGrid',
      title: 'Blogpost Grid',
      template: BlogPostGrid,
    },
  ];
  config.blocks.blocksConfig.listing.icon = listingSVG;

  config.blocks.blocksConfig.carousel = {
    schemaEnhancer: composeSchema(BgColorSchema, FullWidthStyle),
    ...config.blocks.blocksConfig.carousel,
    icon: karousselSVG,
    group: 'teasers',
    mostUsed: false,
    view: BlockStyleWrapper(CarouselView),
    edit: BlockStyleWrapper(CarouselEdit),
  };

  config.blocks.blocksConfig.highlightSlider = {
    ...config.blocks.blocksConfig.highlightSlider,
    restricted: true,
  };

  config.blocks.blocksConfig.imagesGrid = {
    ...config.blocks.blocksConfig.imagesGrid,
    icon: teaserGridSVG,
    availableColors: AVAILABLE_COLORS,
    restricted: true,
  };

  config.blocks.blocksConfig.teaserGrid = {
    ...config.blocks.blocksConfig.teaserGrid,
    view: GridViewBlock,
    edit: GridEditBlock,
    restricted: true,
    icon: teaserGridSVG,
    availableColors: AVAILABLE_COLORS,
    schemaEnhancer: BgColorSchema,
  };

  config.blocks.blocksConfig.teaserTransparent = {
    ...config.blocks.blocksConfig.teaser,
    id: 'teaserTransparent',
    title: 'Teaser Transparent',
    icon: imagesSVG,
    group: 'teasers',
    blockSchema: TeaserSchema,
    dataAdapter: TeaserBlockDataAdapter,
    view: TeaserViewBlock,
    edit: TeaserEditBlock,
    variations: [
      {
        id: 'default',
        isDefault: true,
        title: 'default',
        template: TeaserTransparentTemplate,
      },
    ],
    restricted: true,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };

  config.blocks.blocksConfig.teaserTransparentGrid = {
    id: 'teaserTransparentGrid',
    title: 'Teaser Transparent Grid',
    group: 'teasers',
    view: GridViewBlock,
    edit: GridEditBlock,
    schemaEnhancer: BgColorSchema,
    icon: teaserGridSVG,
    gridAllowedBlocks: ['teaserTransparent'],
    availableColors: AVAILABLE_COLORS,
  };

  config.blocks.blocksConfig.highlightTeaserParallax = {
    id: 'highlightTeaserParallax',
    title: 'Highlight Parallax',
    icon: imagesSVG,
    group: 'teasers',
    view: HighlightTeaserParallaxView,
    edit: HighlightTeaserParallaxEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };

  config.blocks.blocksConfig.highlightTeaser = {
    id: 'highlightTeaser',
    title: 'Highlight Teaser',
    icon: imagesSVG,
    group: 'teasers',
    view: HighlightTeaserView,
    edit: HighlightTeaserEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };

  config.blocks.blocksConfig.highlightTeaserWithoutButton = {
    id: 'highlightTeaserWithoutButton',
    title: 'Highlight',
    icon: imagesSVG,
    group: 'teasers',
    view: HighlightView,
    edit: HighlightEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };

  config.blocks.blocksConfig.members = {
    id: 'members',
    title: 'Members',
    icon: memberSVG,
    group: 'Research Group',
    view:
      config.settings.isHiERNProject === 'true'
        ? HiERNMembersView
        : MembersView,
    edit:
      config.settings.isHiERNProject === 'true'
        ? HiERNMembersEdit
        : MembersEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
    variations: [
      {
        id: 'default',
        isDefault: true,
        title: 'Standard',
        template: MembersView,
      },
      {
        id: 'Without Image',
        title: 'Ohne Bild',
        template: MembersView,
      },
    ],
  };

  config.blocks.blocksConfig.memberList = {
    id: 'memberList',
    title: 'Persons List',
    icon: listingSVG,
    group: 'common',
    view: MemberListView,
    edit: MemberListEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
    variations: [
      {
        id: 'persons',
        title: 'Persons',
        isDefault: true,
        template: MemberListView,
      },
      {
        id: 'personsWithoutImage',
        title: 'Persons without Image',
        template: MemberListView,
      },
      {
        id: 'personsWithoutInstitutes',
        title: 'Persons without Institutes',
        template: MemberListView,
      },
      {
        id: 'personsWithoutInstitutsOrImages',
        title: 'Persons without Instituts/Images',
        template: MemberListView,
      },
      {
        id: 'personsGrid',
        title: 'Persons Grid',
        template: MemberListView,
      },
      {
        id: 'personsGridShort',
        title: 'Persons Grid short',
        template: MemberListView,
      },
      {
        id: 'personsGridWithoutImage',
        title: 'Persons Grid without image',
        template: MemberListView,
      },
    ],
  };

  config.blocks.blocksConfig.teaserTab = {
    id: 'teaserTab',
    title: 'Teaser Tab',
    icon: tabSVG,
    group: 'teasers',
    view: TeaserTabView,
    edit: TeaserTabEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };

  config.blocks.blocksConfig.tabBlock = {
    id: 'tabBlock',
    title: 'Tab Block',
    group: 'common',
    icon: tabBlockSVG,
    view: TabBlockView,
    edit: TabBlockEdit,
    restricted: false,
    mostUsed: false,
    blockHasOwnFocusManagement: true,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };

  config.blocks.blocksConfig.parallaxBlock = {
    id: 'parallaxBlock',
    title: 'Parallax Block',
    group: 'teaser',
    icon: parallaxSVG,
    view: ParallaxView,
    edit: ParallaxEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
    availableColors: ['#000', '#fff'],
  };

  config.blocks.blocksConfig.sliderNew = {
    id: 'sliderNew',
    title: 'Portal Slider',
    group: 'common',
    icon: sliderSVG,
    view: SliderNewView,
    edit: SliderNewEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };

  config.blocks.blocksConfig.socialMedia = {
    id: 'socialMedia',
    title: 'Portal Social Media',
    icon: socialMediaSVG,
    group: 'common',
    view: SocailMediaView,
    edit: SocailMediaEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };

  (config.blocks.blocksConfig.aktuelles = {
    id: 'aktuelles',
    title: 'Aktuelles',
    icon: sliderSVG,
    group: 'teasers',
    view: AktuellesView,
    edit: AktuellesEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  }),
    (config.blocks.blocksConfig.institutslider = {
      id: 'institutslider',
      title: 'Institut Slider',
      group: 'teasers',
      icon: institutsSliderSVG,
      view: InstitutSliderView,
      edit: InstitutSliderEdit,
      restricted: false,
      mostUsed: true,
      sidebarTab: 1,
      security: {
        addPermission: [],
        view: [],
      },
    });

  config.blocks.blocksConfig.teaserWithLink = {
    id: 'teaserWithLink',
    title: 'Teaser-Trenner-Bild',
    group: 'teasers',
    icon: teaserTrennerSVG,
    view: TeaserWithLinkView,
    edit: TeaserWithLinkEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };

  config.blocks.blocksConfig.headline = {
    id: 'headline',
    title: 'Headline',
    icon: headlineSVG,
    group: 'text',
    view: BlockStyleWrapper(HeadlineBlockView),
    edit: BlockStyleWrapper(HeadlineBlockEdit),
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
    schemaEnhancer: composeSchema(BgColorSchema, FullWidthStyle),
  };

  //config.blocks.blocksConfig.__button.availableColors = AVAILABLE_COLORS;

  config.blocks.blocksConfig.introduction = {
    id: 'introduction',
    title: 'Research Group Introduction',
    group: 'Research Group',
    icon: researchGroupSVG,
    view: BlockStyleWrapper(IntroductionView),
    edit: BlockStyleWrapper(IntroductionEdit),
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
    schemaEnhancer: composeSchema(BgColorSchema, FullWidthStyle),
    availableColors: AVAILABLE_COLORS,
  };

  config.blocks.blocksConfig.azlist = {
    id: 'azlist',
    title: 'A-Z List',
    group: 'common',
    icon: listingSVG,
    view:
      config.settings.isHiERNProject === 'true'
        ? BlockStyleWrapper(HiERNAZListView)
        : BlockStyleWrapper(AZListView),
    edit:
      config.settings.isHiERNProject === 'true'
        ? BlockStyleWrapper(HiERNAZListEdit)
        : BlockStyleWrapper(AZListEdit),
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
    schemaEnhancer: composeSchema(BgColorSchema, FullWidthStyle),
  };

  config.blocks.blocksConfig.jofilter = {
    id: 'jofilter',
    title: 'Job Filter',
    group: 'Career',
    icon: heroSVG,
    view: JobFilterBlockView,
    edit: JobFilterBlockEdit,
    restricted: false,
    mostUsed: false,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };

  config.blocks.blocksConfig.altmetric = {
    id: 'altmetric',
    title: 'Altmetric',
    group: 'common',
    icon: freedomSVG,
    view: AltmetricBlockView,
    edit: AltmetricBlockEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };

  config.blocks.blocksConfig.icon = {
    id: 'icon',
    title: 'Icon',
    group: 'common',
    icon: freedomSVG,
    view: IconBlockView,
    edit: IconBlockEdit,
    restricted: true,
    mostUsed: false,
    sidebarTab: 1,
    security: {
      addPermission: [],
      view: [],
    },
  };

  config.blocks.blocksConfig.icons = {
    id: 'icons',
    title: 'Icons',
    group: 'common',
    view: GridStyleWrapper(GridViewBlock),
    edit: GridStyleWrapper(GridEditBlock),
    restricted: false,
    mostUsed: false,
    icon: teaserGridSVG,
    gridAllowedBlocks: ['icon'],
    schemaEnhancer: composeSchema(BgColorSchema, FullWidthStyle),
  };

  config.blocks.blocksConfig.quote = {
    id: 'quote',
    title: 'Quote',
    group: 'text',
    view: BlockStyleWrapper(QuoteBlockView),
    edit: BlockStyleWrapper(QuoteBlockEdit),
    restricted: false,
    mostUsed: false,
    icon: quoteSVG,
    schemaEnhancer: composeSchema(BgColorSchema, FullWidthStyle),
    defaultBGColor: 'grey',
    // availableColors: AVAILABLE_COLORS,
    //defaultColor: AVAILABLE_COLORS[0], // Use grey as default color
    // Enable image field
    showImageField: true,
    sidebarTab: 1,
  };
  config.blocks.blocksConfig.textPillWithStyle = {
    id: 'textPillWithStyle',
    title: 'Text with background color',
    group: 'text',
    view: BlockStyleWrapper(TextBlockView),
    edit: BlockStyleWrapper(TextBlockEdit),
    sidebarTab: 1,
    restricted: false,
    mostUsed: true,
    icon: teaserGridSVG,
    schemaEnhancer: composeSchema(BgColorSchema, FullWidthStyle),
  };
  config.blocks.blocksConfig.__button.view = BlockStyleWrapper(
    config.blocks.blocksConfig.__button.view,
  );
  config.blocks.blocksConfig.__button.edit = BlockStyleWrapper(
    config.blocks.blocksConfig.__button.edit,
  );
  config.blocks.blocksConfig.__button.schemaEnhancer = composeSchema(
    BgColorSchema,
    FullWidthStyle,
  );

  config.blocks.blocksConfig.separator = {
    ...config.blocks.blocksConfig.separator,
    schemaEnhancer: null,
    group: 'common',
  };

  // Ensure we use the Teaser Block from volto and not volto-blocks-grid
  config.blocks.blocksConfig.teaser = {
    ...config.blocks.blocksConfig.teaser,
    restricted: true,
    variations: [
      {
        id: 'default',
        isDefault: true,
        title: 'default',
        template: DefaultBody,
      },
    ],
  };

  // Ensure Grid variants have blocksConfig available see Jugit#1388
  config.blocks.blocksConfig.__grid.blocksConfig = cloneDeep(
    config.blocks.blocksConfig,
  );

  config.blocks.blocksConfig.description = {
    ...config.blocks.blocksConfig.description,
    restricted: true,
  };

  if (additionalExpressMiddlewareServerConfig) {
    config.settings.expressMiddleware = [
      ...config.settings.expressMiddleware,
      ...additionalExpressMiddlewareServerConfig,
    ];
  }
  config.slots = {
    asideRightSlot: [],
  };

  config.settings.supportedLanguages.forEach((lang) => {
    config.slots.asideRightSlot.push({
      id: `slot-navigation-${lang}`,
      path: `/${lang}/**`,
      component: ContextNavigation,
      props: { params: { no_thumbs: true } },
    });
  });
  // This is because it's not in Volto yet. TODO: remove when slots are in core
  //configRegistry.slots = config.slots;

  // --
  // View type mapping for the search results in support of Search.jsx
  // --

  // View mapper can be specified here. with the desired type rendererers.
  // The default view applies for all content types not in the array.
  // Or just use the built in mapper.
  config.views.contentTypeSearchResultViews = {
    Member: searchResultItems.MemberResultItem,
    Meldung: searchResultItems.MeldungResultItem,
    Event: searchResultItems.EventResultItem,
    // XXX Use default view for Joboffer for now. #DLR-38
    // Joboffer: searchResultItems.JobofferResultItem,
    Image: searchResultItems.ImageResultItem,
    Intro: searchResultItems.IntroResultItem,
  };
  config.views.contentTypeSearchResultDefaultView =
    searchResultItems.DefaultResultItem;

  // Icon types. This will be in effect with all supported
  // content type templates.
  config.settings.contentTypeSearchResultIcons = {
    Document: pageSVG,
    File: fileSVG,
    Folder: folderSVG,
    Link: linkSVG,
    Image: imageSVG,
    Meldung: newsSVG,
    'FAQ Item': bookSVG,
    Event: eventSVG,
    OE: enterpriseSVG,
    Regelung: blogSVG,
  };
  config.settings.contentTypeSearchResultDefaultIcon = pageSVG;

  // Wrapper for a customized Solr Search component that can be used
  // directly as a route. On long term these parameters could be acquired from Search.jsx and
  // this wrapper could go away.
  config.widgets.SolrSearch = (props) =>
    Search({
      ...props,
      searchAction: solrSearchContent,
      getSearchReducer: (state) => state.solrsearch,
      contentTypeSearchResultViews: config.views.contentTypeSearchResultViews,
      contentTypeSearchResultDefaultView:
        config.views.contentTypeSearchResultDefaultView,
    });

  config.settings.fontCombinationMap = {
    default: { headers: 'Arial', main: 'Arial' },
    'impact-arialNarrow': { headers: 'Impact', main: 'Arial Narrow' },
    'georgia-lucidaSans': {
      headers: 'Georgia',
      main: 'Lucida Sans, Lucida Grande',
    },
    Metropolis: { headers: 'Metropolis', main: 'Lucida Sans' },
  };

  config.settings.nonContentRoutes.push(
    /\/@@search$/,
    /\/unlock-form$/,
    /\/@cart(-checkout(\/.*)?)?$/,
    /.*\/@@search/,
    '/links-to-item',
  );

  config.settings.DSGVOBanner.tracker = {
    type: 'matomo',
    id: 58,
    urlBase: 'https://apps.fz-juelich.de/piwik/',
  };
  (config.settings.DSGVOBanner.showBanner = true),
    (config.settings.DSGVOBanner.modules = [
      'tracking',
      'youtube',
      'facebook',
      'google',
    ]);
  config.settings.DSGVOBanner.privacy_url = {
    de: '/de/datenschutz',
    en: '/en/privacy-policy',
  };

  // Initially disable banner until activated by fzjsettings (having a matomo_id)
  if (config.settings.isFZJProject || config.settings.isHiERNProject) {
    config.settings.DSGVOBanner.showBanner = false;
  }

  //Use etracker only on main site
  if (!config.settings.isHiERNProject && !config.settings.isFZJProject) {
    config.settings.DSGVOBanner.modules = [
      'tracking',
      'youtube',
      'facebook',
      'etracker',
      'google',
    ];

    config.settings.appExtras.push(
      {
        match: '/de/karriere',
        component: ETrackerScript,
      },
      {
        match: '/en/careers',
        component: ETrackerScript,
      },
    );
  }

  config.addonRoutes.push({
    path: `/@@search`,
    component: config.widgets.SolrSearch,
  });
  config.addonRoutes.push({
    path: `/**/@@search`,
    component: config.widgets.SolrSearch,
  });
  config.addonRoutes.push({
    path: '/**/@cart',
    exact: true,
    component: CartBasket,
  });
  config.addonRoutes.push({
    path: '/@cart-checkout',
    exact: false,
    component: CartCheckout,
  });
  config.addonRoutes.push({
    path: '/profil',
    exact: true,
    component: CentralProfile,
  });
  config.addonRoutes.push({
    path: `/(${config.settings?.supportedLanguages.join('|')})/search`,
    component: config.widgets.SolrSearch,
  });
  config.addonRoutes.push({
    path: `/search`,
    component: config.widgets.SolrSearch,
  });
  config.addonRoutes.push({
    path: `/(${config.settings?.supportedLanguages.join('|')})/**/unlock-form`,
    component: UnlockFormView,
  });

  config.registerComponent({
    name: 'Image',
    component: Image,
  });

  // Disable the robots.txt middleware as it blocks the static file from public/
  if (__SERVER__) {
    config.settings.expressMiddleware = config.settings.expressMiddleware.filter(function(el) { return el.id != "robots.txt"})
  }

  return config;
}
